

import Login from "./components/Login";
import Dashboard from "./containers/Dashboard";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {useEffect, useRef} from "react";

import SocketIOClient from 'socket.io-client'; 
import { useDispatch } from "react-redux";
import { SOCKET_URL,BASE_URL } from "./constants/defaultValues";
import { fetchAllNotifications,fetchNotifications,fetchSilentMessage,fetchSilentChat,fetchSilentVoicemails,fetchSilentVoiceChat,fetchPreferences, saveFcmToken } from "./redux/action";
import {initPushMessaging} from "./constants/firebase";

var socket = SocketIOClient(SOCKET_URL);

function App() {
  const pushInitRef = useRef(false);

  const dispatch=useDispatch()
  const navigate = useNavigate();


  const authUser=useSelector((state)=>state.authUser)
  let audio = new Audio(`${BASE_URL}/sounds/beep.mp3`)

  const isSafari=()=> {
    var chr = window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    var sfri = window.navigator.userAgent.toLowerCase().indexOf("safari") > -1;
    return !chr && sfri;
}

const callback_onAutoplayBlocked = () => {
  return;
}

  const _checkAutoPlay=(p)=> {
    var s = window['Promise'] ? window['Promise'].toString() : '';
    //var self = this
    if (s.indexOf('function Promise()') !== -1 || s.indexOf('function ZoneAwarePromise()') !== -1) {
        p.catch(function(error) {
            console.error("_checkAutoPlay, error:", error)
            if(error.name == "NotAllowedError") { // For Chrome/Firefox
                console.error("_checkAutoPlay: error.name:", "NotAllowedError")
                callback_onAutoplayBlocked();
            } else if (error.name == "AbortError" && isSafari()) {  // Only for Safari
                console.error("_checkAutoPlay: AbortError (Safari)")
                callback_onAutoplayBlocked();
            } else {
                console.error("_checkAutoPlay: happened something else ", error);
                // throw error; // happened something else
            }
        }).then(function(){
            console.log("_checkAutoPlay: then");
            // Auto-play started
        });
    } else {
        console.error("_checkAutoplay: promise could not work in your browser ", p);
    }
}




  const showTextNotifications=(accountName)=>{
    _checkAutoPlay(audio.play())
  }
  const showVoiceNotifications=(accountName)=>{
    _checkAutoPlay(audio.play())
  }

 

  useEffect(()=>{
    if(authUser.user){
    let { activeAccount, user } =  authUser
    let accounts = user?.accounts



    if(accounts){
    accounts.forEach(account => {
      console.log(account.id)
      socket.on(`msg-channel/${account.id}`, (data) => {
        console.log("Inside message channel")
        dispatch(fetchAllNotifications())
        if( account.id == activeAccount ){
          dispatch(fetchNotifications())
          dispatch(fetchSilentMessage())
          dispatch(fetchSilentChat())
        }
        if( data ){
          data = JSON.parse(data)
          if(data.notification){
            showTextNotifications(account.name);
          }
        }              
        
      });
      socket.on(`voice-mail-channel/${account.id}`, (data) => {
        dispatch(fetchAllNotifications())
        if( account.id == activeAccount ){
          dispatch(fetchNotifications())
          dispatch(fetchSilentVoicemails())
          dispatch(fetchSilentVoiceChat())
        }
        if( data ){
          data = JSON.parse(data) 
          if(data.notification){
            showVoiceNotifications(account.name);
          }
        }
      });
    });
  }
    dispatch(fetchAllNotifications())
    dispatch(fetchNotifications())
    dispatch(fetchPreferences())
}
  },[])

  useEffect(()=>{
    var version = localStorage.getItem('version');
    let currentVersion = 3;
    if( version != currentVersion ){
      localStorage.setItem("version",currentVersion)
      localStorage.removeItem('user_id');
      localStorage.removeItem('user');
      window.location = '/'
    }
  
  },[])

  useEffect(() => {
    if (!authUser.user) return;
    if (pushInitRef.current) return;
    pushInitRef.current = true;

    initPushMessaging()
        .then(result => {
          if (result && result.token) {
            const res = dispatch(saveFcmToken(result.token));
          }
        })
        .catch(err => {
          console.error("initPushMessaging error:", err);
        });
  }, [authUser.user]);

  useEffect(() => {
    if (!authUser.user) {
      navigate("/login");
    }
  }, []);

  return (
    <div>
      
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/messages"/>}/>
        <Route path="/messages" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/"/>}/>
      </Routes>
    </div>
  );
}

export default App;
